import { render, staticRenderFns } from "./addVirtualDict.vue?vue&type=template&id=5b9aff2e&"
import script from "./addVirtualDict.vue?vue&type=script&lang=js&"
export * from "./addVirtualDict.vue?vue&type=script&lang=js&"
import style0 from "./addVirtualDict.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b9aff2e')) {
      api.createRecord('5b9aff2e', component.options)
    } else {
      api.reload('5b9aff2e', component.options)
    }
    module.hot.accept("./addVirtualDict.vue?vue&type=template&id=5b9aff2e&", function () {
      api.rerender('5b9aff2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/System/dictionary/addVirtualDict.vue"
export default component.exports